import $ from 'jquery';
import ww from './globals.js';

// all libs
import './libs/sliders.js';
import '../../node_modules/@fancyapps/fancybox/dist/jquery.fancybox.min.js';
import './libs/fancybox.js';

//utils
import './utils/rating.js';

// Pages
import './pages/home.js';
